import { render } from "./HelloWorld.vue?vue&type=template&id=5fe06e43&scoped=true&ts=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=5fe06e43&lang=scss&scoped=true"

import exportComponent from "/home/pk/projects/Tha_Chamber/thachamber/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe06e43"]])

export default __exports__